import { Component, DoCheck, OnDestroy, OnInit } from "@angular/core";
import { Search } from "./common/search";
import { Multilingua } from "./model/multilingua";
import { MultilinguaService } from "./service/multilingua.service";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { concatMap, map } from "rxjs/operators";
import { from, Subscription } from "rxjs"; // RxJS 6 syntax
import { MenuService } from "./service/menu.service";
import {
  MENU_PRIMARY_ENG,
  MENU_PRIMARY_ITA,
  MENU_PRIMARY_PT,
  MENU_SECONDARY_ENG,
  MENU_SECONDARY_ITA,
  MENU_SECONDARY_PT,
  MENU_BOTTOM_PRIMARY_ITA,
  MENU_BOTTOM_SECONDARY_ITA,
  MENU_BOTTOM_PRIMARY_ENG,
  MENU_BOTTOM_SECONDARY_ENG,
  MENU_BOTTOM_PRIMARY_PT,
  MENU_BOTTOM_SECONDARY_PT,
} from "./constants/constants";
import { Quotazione } from "./model/quotazione.model";
import { QuotazioneService } from "./service/quotazione.service";
import { SeoService } from "./service/seo.service";
import {
  NgcCookieConsentService,
  NgcInitializeEvent,
  NgcNoCookieLawEvent,
  NgcStatusChangeEvent,
} from "ngx-cookieconsent";

//declare var _iub: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, OnDestroy, DoCheck {
  // keep refs to subscriptions to be able to unsubscribe later
  private popupOpenSubscription: Subscription;
  private popupCloseSubscription: Subscription;
  private initializeSubscription: Subscription;
  private statusChangeSubscription: Subscription;
  private revokeChoiceSubscription: Subscription;
  private noCookieLawSubscription: Subscription;

  public year: number = new Date().getFullYear();
  public showSidebar = false;
  public display = false;
  path = "";
  alternativePath = "";

  alternativesLang = ["IT", "EN"];

  alternativesMapPath: string;
  alternativesMapUnchecked = {};
  alternativesMap = {};

  menuSecondary: any[];
  menuPrimary: any[];
  menuSecondaryBottom: any[];
  menuPrimaryBottom: any[];

  menuLanguage: any[];

  menuPrimaryIta = MENU_PRIMARY_ITA;
  menuSecondaryIta = MENU_SECONDARY_ITA;
  menuPrimaryBottomIta = MENU_BOTTOM_PRIMARY_ITA;
  menuSecondaryBottomIta = MENU_BOTTOM_SECONDARY_ITA;
  menuPrimaryEng = MENU_PRIMARY_ENG;
  menuSecondaryEng = MENU_SECONDARY_ENG;
  menuPrimaryBottomEng = MENU_BOTTOM_PRIMARY_ENG;
  menuSecondaryBottomEng = MENU_BOTTOM_SECONDARY_ENG;

  menuPrimaryPt = MENU_PRIMARY_PT;
  menuSecondaryPt = MENU_SECONDARY_PT;
  menuPrimaryBottomPt = MENU_BOTTOM_PRIMARY_PT;
  menuSecondaryBottomPt = MENU_BOTTOM_SECONDARY_PT;
  lang: string;
  quotazione: Quotazione;

  constructor(
    public router: Router,
    private location: Location,
    private multilinguaService: MultilinguaService,
    private menuService: MenuService,
    private seoService: SeoService,
    private ccService: NgcCookieConsentService,
    private quotazioneService: QuotazioneService
  ) {
    menuService.itemChanged$.subscribe((item) => this.onItemChanged(item));
    menuService.lang$.subscribe((lang) => this.onItemLang(lang));
    this.quotazioneService.latest().subscribe((borsa) => {
      this.quotazione = borsa.items;
    });
  }

  loadMenus() {
    // console.log('loadMenus');
    if (this.lang === "IT") {
      this.menuPrimary = this.menuPrimaryIta;
      this.menuSecondary = this.menuSecondaryIta;
      this.menuPrimaryBottom = this.menuPrimaryBottomIta;
      this.menuSecondaryBottom = this.menuSecondaryBottomIta;
      // if (_iub != null) {
      //     _iub.csConfiguration['lang'] = 'it';
      // }
    } else if (this.lang === "EN") {
      this.menuPrimary = this.menuPrimaryEng;
      this.menuSecondary = this.menuSecondaryEng;
      this.menuPrimaryBottom = this.menuPrimaryBottomEng;
      this.menuSecondaryBottom = this.menuSecondaryBottomEng;
      // if (_iub != null) {
      //     _iub.csConfiguration['lang'] = 'en';
      // }
    } else if (this.lang === "PT") {
      this.menuPrimary = this.menuPrimaryPt;
      this.menuSecondary = this.menuSecondaryPt;
      this.menuPrimaryBottom = this.menuPrimaryBottomPt;
      this.menuSecondaryBottom = this.menuSecondaryBottomPt;
      // if (_iub != null) {
      //     _iub.csConfiguration['lang'] = 'en';
      // }
    }
    // console.log('_iub: ' + _iub.csConfiguration['lang']);
  }

  onItemLang(lang: string): void {
    // console.log('change lang');
    this.lang = lang;
    this.loadMenus();
    this.seo();
  }

  onItemChanged(languages: any): void {
    // console.log('change menu languages');
    this.menuLanguage = [];
    for (const lingua of languages) {
      this.menuLanguage.push({ titolo: lingua });
    }
  }

  seo() {
    const splitedPath = this.location.path().split("/");
    // console.log('dove andare: ' + lang + ', splitedPath: ' + splitedPath);
    const pageElement = splitedPath.pop();
    const ob = [];

    this.multilinguaService.search = new Search<Multilingua>(Multilingua);
    if (this.lang === "IT") {
      this.multilinguaService.search._.it = pageElement;
    } else if (this.lang === "EN") {
      this.multilinguaService.search._.eng = pageElement;
    } else if (this.lang === "PT") {
      this.multilinguaService.search._.pt = pageElement;
    }

    this.multilinguaService.getList().subscribe((res) => {
      if (res && res.length > 0) {
        const multilingua: Multilingua = res[0];
        switch (this.lang) {
          case "EN":
            this.seoService.setAll(
              multilingua.eng_keywords,
              multilingua.eng_title,
              multilingua.eng_description,
              this.lang
            );
            break;
          case "PT":
            this.seoService.setAll(
              multilingua.pt_keywords,
              multilingua.pt_title,
              multilingua.pt_description,
              this.lang
            );
            break;
          default:
            this.seoService.setAll(
              multilingua.it_keywords,
              multilingua.it_title,
              multilingua.it_description,
              this.lang
            );
        }
      }
    });
  }

  setLanguage(lang: string) {
    const splitedPath = this.location.path().split("/");
    // console.log('dove andare: ' + lang + ', splitedPath: ' + splitedPath);
    const pageElement = splitedPath.pop();
    const ob = [];

    this.multilinguaService.search = new Search<Multilingua>(Multilingua);
    if (this.lang === "IT") {
      this.multilinguaService.search._.it = pageElement;
    } else if (this.lang === "EN") {
      this.multilinguaService.search._.eng = pageElement;
    } else if (this.lang === "PT") {
      this.multilinguaService.search._.pt = pageElement;
    }

    this.lang = lang;
    if (this.lang === "IT") {
      this.menuPrimary = this.menuPrimaryIta;
      this.menuSecondary = this.menuSecondaryIta;
      this.menuPrimaryBottom = this.menuPrimaryBottomIta;
      this.menuSecondaryBottom = this.menuSecondaryBottomIta;
    } else if (this.lang === "EN") {
      this.menuPrimary = this.menuPrimaryEng;
      this.menuSecondary = this.menuSecondaryEng;
    } else if (this.lang === "PT") {
      this.menuPrimary = this.menuPrimaryPt;
      this.menuSecondary = this.menuSecondaryPt;
    }

    this.multilinguaService.getList().subscribe((res) => {
      if (res.length > 0) {
        const multilingua: Multilingua = res[0];

        this.path = "";
        if (splitedPath.toString().trim().length <= 0) {
          // console.log('sono qui');
          if (this.lang === "IT") {
            this.path = "/" + res[0].it;
            // this.seoService.setDescription(multilingua.it_description);
            // this.seoService.setKeywords(multilingua.it_keywords);
            // this.seoService.setTitle(multilingua.it_title);
            // this.seoService.setLang(this.lang);
          } else if (this.lang === "EN") {
            this.path = "/" + res[0].eng;
            // this.seoService.setDescription(multilingua.eng_description);
            // this.seoService.setKeywords(multilingua.eng_keywords);
            // this.seoService.setTitle(multilingua.eng_title);
            // this.seoService.setLang(this.lang);
          } else if (this.lang === "PT") {
            this.path = "/" + res[0].pt;
            // this.seoService.setDescription(multilingua.eng_description);
            // this.seoService.setKeywords(multilingua.eng_keywords);
            // this.seoService.setTitle(multilingua.eng_title);
            // this.seoService.setLang(this.lang);
          }
          this.router.navigate([this.path]);
        } else {
          for (const element of splitedPath) {
            if (element.trim().length > 0) {
              this.multilinguaService.search = new Search<Multilingua>(
                Multilingua
              );
              if (this.lang === "IT") {
                this.multilinguaService.search._.eng = element;
              } else if (this.lang === "EN") {
                this.multilinguaService.search._.it = element;
              } else if (this.lang === "PT") {
                this.multilinguaService.search._.pt = element;
              }
              ob.push(
                this.multilinguaService.getAllList().pipe(
                  map((associazione) => {
                    if (associazione.length > 0) {
                      if (this.lang === "IT") {
                        this.path = this.path + "/" + associazione[0].it;
                      } else if (this.lang === "EN") {
                        this.path = this.path + "/" + associazione[0].eng;
                      } else if (this.lang === "PT") {
                        this.path = this.path + "/" + associazione[0].pt;
                      }
                    } else {
                      // non so se puo funzionare
                      this.path = this.path + element;
                    }
                  })
                )
              );
            }
          }
          from(ob)
            .pipe(concatMap((el) => el))
            .subscribe((val) => {
              if (this.lang === "IT") {
                this.path = this.path + "/" + res[0].it;
              } else if (this.lang === "EN") {
                this.path = this.path + "/" + res[0].eng;
              } else if (this.lang === "PT") {
                this.path = this.path + "/" + res[0].pt;
              }
              this.router.navigate([this.path]);
            });
        }
      } else {
        this.router.navigate([this.location.path()]);
      }
    });
  }

  sanitizeIT(): string {
    // tslint:disable-next-line:max-line-length
    return (
      "" +
      // tslint:disable-next-line:max-line-length
      ""
    );
  }

  sanitizeEN(): string {
    // tslint:disable-next-line:max-line-length
    return (
      "" +
      // tslint:disable-next-line:max-line-length
      ""
    );
  }

  sanitizePT(): string {
    // tslint:disable-next-line:max-line-length
    return (
      "" +
      // tslint:disable-next-line:max-line-length
      ""
    );
  }

  ngOnInit() {
    // subscribe to cookieconsent observables to react to main events
    this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(() => {
      // you can use this.ccService.getConfig() to do stuff...
    });

    this.popupCloseSubscription = this.ccService.popupClose$.subscribe(() => {
      // you can use this.ccService.getConfig() to do stuff...
    });

    this.initializeSubscription = this.ccService.initialize$.subscribe(
      (event: NgcInitializeEvent) => {
        // you can use this.ccService.getConfig() to do stuff...
      }
    );

    this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
      (event: NgcStatusChangeEvent) => {
        // you can use this.ccService.getConfig() to do stuff...
      }
    );

    this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(
      () => {
        // you can use this.ccService.getConfig() to do stuff...
      }
    );

    this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe(
      (event: NgcNoCookieLawEvent) => {
        // you can use this.ccService.getConfig() to do stuff...
      }
    );
  }

  ngOnDestroy() {
    // unsubscribe to cookieconsent observables to prevent memory leaks
    this.popupOpenSubscription.unsubscribe();
    this.popupCloseSubscription.unsubscribe();
    this.initializeSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
    this.revokeChoiceSubscription.unsubscribe();
    this.noCookieLawSubscription.unsubscribe();
  }

  ngDoCheck() {
    this.fillLanguages();
    this.alternativesMap = this.alternativesMapUnchecked;
  }

  refillLanguages() {
    this.alternativesMapPath = null;
    this.fillLanguages();
  }

  fillLanguages() {
    // sia il ts che html ciclano su questa proprietà
    const langs = this.alternativesLang;

    // se il path è quello corrente non rifaccio il giro
    if (this.alternativesMapPath === this.location.path()) {
      return;
    }

    const splitedPath = this.location.path().split("/");
    // console.log('dove andare: ' + lang + ', splitedPath: ' + splitedPath);
    const pageElement = splitedPath.pop();
    if (pageElement == null || pageElement.trim().length === 0) {
      return;
    }

    // inizializzo la ricerca
    this.multilinguaService.search = new Search<Multilingua>(Multilingua);
    if (this.lang === "IT") {
      this.multilinguaService.search._.it = pageElement;
    } else if (this.lang === "EN") {
      this.multilinguaService.search._.eng = pageElement;
    } else if (this.lang === "PT") {
      this.multilinguaService.search._.pt = pageElement;
    } else {
      // non riesco a inizializzare la ricerca. non la faccio
      return;
    }

    // tengo traccia del fatto che il calcolo varrà per questo path
    this.alternativesMapUnchecked = {};
    this.alternativesMapPath = this.location.path();

    this.multilinguaService.getList().subscribe((res) => {
      // se non ho alternative ogni lang mi riporta sulla pagina corrente
      if (res != null && res.length === 0) {
        for (const lang of langs) {
          this.alternativesMapUnchecked[lang] = this.location.path();
        }
        return;
      }

      // se il path è di un solo blocco
      if (res && splitedPath.toString().trim().length <= 0) {
        for (const lang of langs) {
          let path = "";
          if (lang === "IT") {
            path = "/" + res[0].it;
          } else if (lang === "EN") {
            path = "/" + res[0].eng;
          } else if (lang === "PT") {
            path = "/" + res[0].pt;
          }
          this.alternativesMapUnchecked[lang] = path;
        }
        return;
      }

      // altrimenti devo fare il multilingua di ogni pezzo
      for (const lang of langs) {
        const ob = [];
        this.alternativesMapUnchecked[lang] = "";
        for (const splittedPathPart of splitedPath) {
          if (splittedPathPart.trim().length > 0) {
            this.multilinguaService.search = new Search<Multilingua>(
              Multilingua
            );
            if (this.lang === "IT") {
              this.multilinguaService.search._.it = splittedPathPart;
            } else if (this.lang === "EN") {
              this.multilinguaService.search._.eng = splittedPathPart;
            } else if (this.lang === "PT") {
              this.multilinguaService.search._.pt = splittedPathPart;
            }
            ob.push(
              this.multilinguaService.getAllList().pipe(
                map((associazione) => {
                  if (associazione.length > 0) {
                    if (lang === "IT") {
                      this.alternativesMapUnchecked[lang] =
                        this.alternativesMapUnchecked[lang] +
                        "/" +
                        associazione[0].it;
                    } else if (lang === "EN") {
                      this.alternativesMapUnchecked[lang] =
                        this.alternativesMapUnchecked[lang] +
                        "/" +
                        associazione[0].eng;
                    } else if (lang === "PT") {
                      this.alternativesMapUnchecked[lang] =
                        this.alternativesMapUnchecked[lang] +
                        "/" +
                        associazione[0].pt;
                    }
                  } else {
                    // non so se puo funzionare
                    this.alternativesMapUnchecked[lang] =
                      this.alternativesMapUnchecked[lang] + splittedPathPart;
                  }
                })
              )
            );
          }
        }
        from(ob)
          .pipe(concatMap((el) => el))
          .subscribe((val) => {
            if (lang === "IT") {
              this.alternativesMapUnchecked[lang] =
                this.alternativesMapUnchecked[lang] + "/" + res[0].it;
            } else if (lang === "EN") {
              this.alternativesMapUnchecked[lang] =
                this.alternativesMapUnchecked[lang] + "/" + res[0].eng;
            } else if (lang === "PT") {
              this.alternativesMapUnchecked[lang] =
                this.alternativesMapUnchecked[lang] + "/" + res[0].pt;
            }
          });
      }
    });
  }
}
